import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import UpdateLuckyWheelForm from '../UpdateLuckyWheelForm'
import { Button } from '@/common/ui/button'
import { ArrowLeft } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import useQueryGetLuckyWheel from '@/modules/promotion/api/hooks/useQueryGetLuckyWheel'

export default function UpdateLuckyWheelListing() {
	const navigate = useNavigate()
	const { data: defaultValues, isLoading } = useQueryGetLuckyWheel()

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`ตั้งค่ากงล้อ`}
					description="โควตากงล้อจะคิดเมื่อลูกค้าเล่นด้วยเงินติดเงื่อนไข promotion เท่านั้น"
				/>
				<Button type="button" variant="outline" onClick={() => navigate(-1)}>
					<ArrowLeft className="mr-2 h-4 w-4" />
					กลับ
				</Button>
			</div>
			{defaultValues && (
				<UpdateLuckyWheelForm
					defaultValues={defaultValues}
					isLoading={isLoading}
				/>
			)}
			<Separator />
		</div>
	)
}
